import React, { useState, useEffect } from 'react';
import { Shield, AlertCircle } from 'lucide-react';
import { tosData } from '../data/mock';

const TOS = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="pt-32 pb-20 px-4">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div
          className={`text-center mb-12 transition-all duration-700 ${
            visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
          }`}
        >
          <Shield className="w-16 h-16 text-cyan-400 mx-auto mb-4" />
          <h1 className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-cyan-300 via-teal-400 to-cyan-400 bg-clip-text text-transparent mb-4">
            {tosData.title}
          </h1>
        </div>

        {/* TOS Items */}
        <div
          className={`transition-all duration-700 delay-100 ${
            visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
          }`}
        >
          <div className="rounded-xl border bg-gradient-to-br from-stone-800/50 via-neutral-800/40 to-slate-800/50 border-teal-500/30 backdrop-blur-xl shadow-lg shadow-teal-500/10">
            <div className="p-6 md:p-8">
              <ul className="space-y-5">
                {tosData.items.map((item, i) => (
                  <li
                    key={i}
                    className={`flex items-start gap-3 transition-all duration-500 ${
                      visible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-4'
                    }`}
                    style={{ transitionDelay: `${(i + 2) * 100}ms` }}
                  >
                    <AlertCircle className="w-5 h-5 text-cyan-400 mt-0.5 flex-shrink-0" />
                    <span className="text-gray-300 text-base leading-relaxed">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TOS;
